import { render, staticRenderFns } from "./FormPay.vue?vue&type=template&id=688b052c&"
import script from "./FormPay.vue?vue&type=script&lang=js&"
export * from "./FormPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports